const FieldType = Object.freeze({
  SELECT: 'select',
  INPUT: 'input',
  DATE: 'date',
  DATEPICKER: 'datepicker',
  PHONE: 'phone',
  PASSWORD: 'password',
  TEXTAREA: 'textarea',
  TEXT: 'text',
  EMAIL: 'email',
  GROUP: 'group',
})

export default FieldType